<section id="comparison" class="section reveal reveal--fade-up" s2eReveal aria-labelledby="comparison-heading">
  <div class="section__head">
    <div class="section__headings">
      <h2 class="section__title" id="comparison-heading">{{ 'comparison.title' | reportT }}</h2>
      <p class="section__desc">{{ 'comparison.subtitle' | reportT }}</p>
    </div>
  </div>

  <article class="card comparison-card" data-print-block>
    <div class="card-content comparison">
      <ul class="chart-legend comparison__legend">
        @for (entry of legend(); track entry.cat) {
          <li class="chart-legend__item">
            <span class="chart-legend__swatch" [attr.data-cat]="entry.cat"
                  [style.background-color]="entry.color" aria-hidden="true"></span>
            <span class="chart-legend__label">{{ entry.key | reportT }}</span>
          </li>
        }
      </ul>

      <!-- Les barres et les libellés de matières demandent de la place ; en
           dessous, le graphique défile dans ce conteneur pour que le corps de
           page, lui, ne défile jamais. -->
      <div class="chart-scroll">
        <div class="chart-min chart-min--560">
          <s2e-comparison-chart
            [rows]="cross().comparison"
            [theme]="chrome.theme()"
            [rtl]="chrome.rtl()"
            [seriesLabels]="seriesLabels()"
            [percentFormat]="percentFormat()"
            [ariaLabel]="ariaLabel()"
          />
        </div>
      </div>
    </div>
  </article>
</section>
